import React, { useState } from 'react';
import { Button, Skeleton } from 'antd';
import { CloseXIcon, TickCircleIcon } from 'icons';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { uid } from 'uid';

import { useAppSelector } from 'store';

import { Modal } from 'components';

import { useAvatar, useSaveAvatar } from '../hooks';

interface IProps {
  open: boolean;
  onClose: () => void;
}

const AvatarChangeModal: React.FC<IProps> = ({ open, onClose }) => {
  const t = useTranslations();
  const { avatars, isLoading } = useAvatar(open);
  const userImage = useAppSelector(state => state.user.image);
  const [selectedAvatar, setSelectedAvatar] = useState<string | null>(userImage);
  const { mutate, isLoading: saveLoading } = useSaveAvatar(onClose);

  const handleSelectAvatar = (avatar: string) => {
    setSelectedAvatar(avatar);
  };

  return (
    <Modal
      footer={
        <Button
          onClick={() => mutate(selectedAvatar)}
          loading={saveLoading}
          disabled={!selectedAvatar}
          className="!mt-5 !w-full !rounded-lg !border-transparent !bg-green-500 !py-4 !text-white disabled:!bg-gray-300 disabled:!text-white"
        >
          {t('profile.saqlash')}
        </Button>
      }
      open={open}
      centered
      onClose={onClose}
      width="421px"
      height="60%"
      styles={{
        content: { padding: '16px', borderRadius: '12px' }
      }}
      closeIcon={
        <div className="flex items-center justify-center rounded-full bg-gray-800 p-1 text-white">
          <CloseXIcon size="12" />
        </div>
      }
      title={<span className="text-lg">{t('Avatarkalar')}</span>}
    >
      <div className="grid grid-cols-5 gap-4">
        {isLoading
          ? // eslint-disable-next-line react/no-array-index-key
            Array.from({ length: 12 }).map((_, index) => <Skeleton.Avatar key={index} active size={72} />)
          : avatars?.map(avatar => {
              const isSelected = selectedAvatar === avatar;

              return (
                <div key={uid()} className="relative">
                  <div
                    className={`w-18 h-18 relative cursor-pointer overflow-hidden rounded-full border-2 transition-all ${
                      isSelected ? 'border-green-500' : 'border-transparent'
                    }`}
                    onClick={() => handleSelectAvatar(avatar)}
                  >
                    <Image alt={`avatar-${uid()}`} src={avatar} layout="fill" objectFit="cover" title='Foydalanuvchiga tavsiya etiladigon avatarlar' />
                  </div>
                  {isSelected && (
                    <div className="absolute -bottom-[8px] left-1/2 ml-[2.5px] flex -translate-x-1/2 items-center justify-center rounded-full border-2 border-none bg-green-500">
                      <TickCircleIcon />
                    </div>
                  )}
                </div>
              );
            })}
      </div>
    </Modal>
  );
};

export default AvatarChangeModal;
